import { Link } from 'react-router-dom'
import { useTasks } from '@/hooks/useTasks'
import { LoadingSpinner } from '@/components/ui/loading-spinner'
import { useWorkerStore } from '@/stores/worker.store'
import { workerRoutes } from '@/lib/navigation/routes'
import { Inbox, Play, CheckCircle } from 'lucide-react'

export function WorkerDashboard() {
  const workerName = useWorkerStore(s => s.workerName)
  const { data: tasks, isLoading } = useTasks()

  if (isLoading) return <LoadingSpinner className="mt-20" />

  const allTasks = tasks ?? []
  const newTasks = allTasks.filter(t => t.status === 'new')
  const activeTasks = allTasks.filter(t => t.status === 'in_progress')
  const completedTasks = allTasks.filter(t => t.status === 'completed')

  const statCards = [
    { icon: <Inbox className="h-6 w-6 text-blue-600" />, label: 'Новых заданий', value: newTasks.length, bg: 'bg-blue-50' },
    { icon: <Play className="h-6 w-6 text-orange-600" />, label: 'В работе', value: activeTasks.length, bg: 'bg-orange-50' },
    { icon: <CheckCircle className="h-6 w-6 text-green-600" />, label: 'Завершено', value: completedTasks.length, bg: 'bg-green-50' },
  ]

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-2">
        Привет, {workerName || 'работник'}!
      </h1>
      <p className="text-gray-500 mb-6">
        <Link to={workerRoutes.tasks.path} className="text-blue-600 hover:text-blue-800 font-medium">
          Перейти к заданиям →
        </Link>
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
        {statCards.map((c) => (
          <div key={c.label} className="bg-white rounded-xl border border-gray-200 p-5">
            <div className="flex items-center gap-4">
              <div className={`${c.bg} rounded-lg p-3`}>{c.icon}</div>
              <div>
                <p className="text-sm text-gray-500">{c.label}</p>
                <p className="text-2xl font-bold text-gray-900">{c.value}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="text-center text-gray-500 py-12 bg-white rounded-lg border border-gray-200">
        <p className="text-lg">Сводка по статусам заданий</p>
        <p className="text-sm mt-1">Откройте список заданий для работы на посту</p>
      </div>
    </div>
  )
}
